import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Heart, Loader2, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { getApiBase } from '../utils/apiBase';

const API = getApiBase();

/**
 * Stable frontend path /q/:shortCode → resolves via API → published memorial page.
 * Legacy /q/memorial/:qrId is supported for older printed codes.
 */
export default function MemorialQrRedirect() {
  const { shortCode, qrId } = useParams();
  const code = useMemo(() => (shortCode || qrId || '').trim().toLowerCase(), [shortCode, qrId]);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    if (!code) {
      setUnavailable(true);
      return undefined;
    }
    let cancelled = false;
    axios
      .get(`${API}/q/${encodeURIComponent(code)}/resolve`)
      .then(({ data }) => {
        if (cancelled) return;
        if (data?.redirect_url) {
          window.location.replace(data.redirect_url);
        } else {
          setUnavailable(true);
        }
      })
      .catch(() => {
        if (!cancelled) setUnavailable(true);
      });
    return () => {
      cancelled = true;
    };
  }, [code]);

  if (unavailable) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[hsl(42_28%_96%)] px-6 text-center">
        <Lock className="h-10 w-10 text-muted-foreground" aria-hidden />
        <p className="font-serif text-xl text-[hsl(24_14%_18%)]">This memorial link is not available</p>
        <p className="max-w-sm text-sm text-muted-foreground">
          The memorial may be private, still in draft, or no longer active. No private archive details are shown here.
        </p>
        <Link to="/" className="text-sm text-[#8b7355] underline-offset-4 hover:underline">
          Return home
        </Link>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[hsl(42_28%_98%)]">
      <Loader2 className="h-8 w-8 animate-spin text-[#8b7355]" aria-label="Opening memorial" />
      <p className="flex items-center gap-2 text-sm text-muted-foreground">
        <Heart className="h-3.5 w-3.5 text-[#c9a961]" aria-hidden />
        Opening memorial page…
      </p>
    </div>
  );
}
